import { connectedStore } from '../../store';
import actions from '../actions';

const setMultilingual = (isMl) => {
  const store = connectedStore.get();
  store.dispatch(actions.setMultilingual(isMl));
};

export default setMultilingual;
